import React from 'react'
import { TextField, IconButton, InputAdornment } from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'

interface PasswordTextFieldProps {
    name: string
    label: string
    value: string
    showPassword: boolean
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    onToggleVisibility: () => void
    showLabel: string
    hideLabel: string
}

export const PasswordTextField: React.FC<PasswordTextFieldProps> = ({
    name,
    label,
    value,
    showPassword,
    onChange,
    onToggleVisibility,
    showLabel,
    hideLabel,
}) => (
    <TextField
        margin="normal"
        required
        fullWidth
        variant="outlined"
        name={name}
        label={label}
        type={showPassword ? 'text' : 'password'}
        id={name}
        autoComplete="new-password"
        value={value}
        onChange={onChange}
        slotProps={{
            input: {
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label={showPassword ? hideLabel : showLabel}
                            onClick={onToggleVisibility}
                            edge="end"
                        >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                ),
            },
        }}
    />
)
